import React, {Component} from 'react'
import {base} from '../../base';
import ProgressButton from './ProgressButton'
import '../../styles/css/CreatorAwards.css'
import Background from '../../styles/images/creator-background-lrg.jpg';

class CompanyVotesBigScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyVotingOn: false,
            companyList: [],
            frozenVotingState: [],
        };
    }

componentDidMount() {
    this.companyListState = base.bindToState('companyList', {
        context: this,
        state: 'companyList',
        asArray: true,
        queries: {
          orderByChild: 'votes',
          limitToLast: 6
        }
    })
    this.companyState = base.bindToState('companyVotingOn', {
        context: this,
        state: 'companyVotingOn'
    })
    this.finalCompanyListState = base.bindToState('finalCompanyList', {
        context: this,
        state: 'frozenVotingState',
        asArray: true,
        queries: {
          orderByChild: 'votes',
        }
    })
}

componentWillUnmount() {
    base.removeBinding(this.companyState);
    base.removeBinding(this.companyListState);
    base.removeBinding(this.finalCompanyListState);
}

render() {
    var companyList = this.state.companyList;
    if(!this.state.companyVotingOn && this.state.frozenVotingState.length > 0){
      companyList = this.state.frozenVotingState;
    }
    var totalVotes = 0;
    if(companyList.length > 0){
      totalVotes = companyList.map(item => item.votes).reduce((prev, next) => prev + next)
    }
    return (
                <div className="grid-wrapper" style={{backgroundImage: `url(${Background})`}}>
                    <div className="grid-container-outer">
                        <div className="grid-left">
                            <div className="creator-awards-logo"><img src={require('../../styles/images/creator-awards-logo.png')} alt=""/></div>
                            {/*<div className="grid-header">
                                <h1>Live Vote</h1>
                            </div>*/}
                        </div>
                        <div className="grid-container-inner">
                          <div style={{height:'30px'}}></div>
                        {
                            companyList.slice(0).reverse().map(function(item,i){
                              var amountFilled = 0;
                              if(totalVotes > 0){
                                amountFilled = item.votes / totalVotes * 100;
                              }
                            return (
                              <div key={i} className="grid-item">
                                <ProgressButton title={item.companyTitle} votes={item.votes} progress={amountFilled}/>
                              </div>
                            )
                          }, this)
                        }
                        </div>
                    </div>
                </div>)
              }
}

export default CompanyVotesBigScreen;



// WEBPACK FOOTER //
// ./src/components/creatorawards/CompanyVotesBigScreen.js